import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthenticatedStoreProviders } from 'src/shared/stores/app-stores';
import { CtaHandlerService } from 'src/symptomchecker/services/cta-handler/cta-handler.service';
import { SessionStateService } from 'src/symptomchecker/services/symptomcheckersession/session-state.service';

/**
 * Authenticated container component
 * Wraps authenticated components and services.
 * This component is used to provide stores to all authenticated components.
 * When this component is destroyed, all services will be destroyed.
 */
@Component({
  selector: 'app-authenticated-container',
  imports: [RouterOutlet],
  providers: [...AuthenticatedStoreProviders, SessionStateService, CtaHandlerService], // Services will be created and destroyed with this wrapper component.
  templateUrl: './authenticated-container.component.html',
  styleUrl: './authenticated-container.component.scss',
})
export class AuthenticatedContainerComponent {}
